import { HttpClient, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map, takeLast } from "rxjs";
import { environment } from "src/environments/environment";
import { Intervention } from "../domain/intervention";
import { CoreData } from "../tools/core-data/core-data";
import { BaseService } from "./base.service";
import { InterventionDTO } from "./dto/intervention.dto";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/loading-task";

@Injectable({
    providedIn: 'root',
})
export class InterventionService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/intervention`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getMyIntervention() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMyIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO[]) => {
                return response.map((item: InterventionDTO) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    getMyInterventionLastMinute() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/CreateFromOSO`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMyInterventionLastMinute')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO[]) => {
                return response.map((item: InterventionDTO) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    geInterventionByCode(interventionCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${interventionCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('geInterventionByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO) => {
                return Intervention.mapFromJSON(response);
            }));
    }

    getInterventionWithQualifSalleOnlyByCode(code: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/qualifsalle/${code}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInterventionWithQualifSalleOnlyByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO) => {
                return Intervention.mapFromJSON(response);
            }));
    }

    getInterventionWithQualifSalleOnlyByFilter(filter?: string) {
        this.loadingTask.activateLoading();
        let params = new HttpParams();
        if (filter) {
            params = params.append('filter', `${filter}`);
        }
        return this.http.get(`${this.serviceUrl}/qualifsalle`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getInterventionWithQualifSalleOnlyByFilter')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO[]) => {
                return response.map((item: InterventionDTO) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    syncIntervention(int: Intervention) {
        this.loadingTask.activateLoading();
        const dto = JSON.stringify(int);
        // return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}/sync`, dto, this.generateHeaderWithEvents()))
        return this.http.put(`${this.serviceUrl}/sync`, dto, this.generateHeader())
        .pipe(
            catchError(this.handleError<any>('sync')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    exportIndexedDBAndLocalStorageAsJSON(jsonDB: any, jsonLocalStorage: any) {
        const formData: FormData = new FormData();

        formData.append('db', jsonDB);
        formData.append('localStorage', jsonLocalStorage);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/dump`, formData, this.generateHeaderForFormData()).pipe(
            catchError(this.handleError<any>('exportIndexedDBAndLocalStorageAsJSON')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}